import React ,{createContext } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

// @ts-ignore
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

type State = {
    open: boolean;
    type: string;
    message: string;
    loading: boolean;
}
//初期データ
const initialState: State = {
    open: false,
    type: "success",
    message: "",
    loading: false,
}

export const ApolloMessage = createContext({} as {
    data: State
    setmsg: React.Dispatch<Action>
});

type Action = {
    type: string ;
    payload: State;
}

// @ts-ignore
const reducer = (state: State, action: Action) => {
    switch (action.type) {
        case 'setMessage':
            return {
                ...state,
                open: action.payload.open,
                type: action.payload.type,
                message: action.payload.message,
            };
        case 'loading':
            return {
                ...state,
                loading: action.payload.loading,
            };
        case 'all':
            return {
                ...state,
                open: action.payload.open,
                type: action.payload.type,
                message: action.payload.message,
                loading: action.payload.loading,
            };
        default:
            return state;
    }
};

export const ApolloMessageProvider: React.FC = ({ ...props }) => {

    const [ data, setmsg] = React.useReducer(reducer, initialState);
    return (
        <ApolloMessage.Provider
            value={ {
                data,
                setmsg,
            } }
        >
            {props.children}
        </ApolloMessage.Provider>
    );
};

export const CustomizedSnackbars = () => {

   // const { open, type, message } = props;
    const {data, setmsg} = React.useContext(ApolloMessage)

    const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setmsg( ({
                type: "setMessage",
                payload: {
                    ...data,
                    open: false
                }
            }));
    };

    const messages = data.message?.split('\r\n');
    return (
        <Snackbar open={data.open} autoHideDuration={10000} onClose={handleClose}>
            <Alert onClose={handleClose} severity={data.type}>
                {messages?.map((message) =>
                  <React.Fragment>
                      {message}<br/>
                  </React.Fragment>
                )}
            </Alert>
        </Snackbar>
    );
};

export const setLoadingMessage = (state: State, loading: boolean) => ({
    type: "loading",
    payload: { ...state, loading: loading },
});

export const setSuccessMessage = (state: State, message: string) => ({
    type: "setMessage",
    payload: { ...state, open: true, type: "success", message: message },
});

export const setWarningMessage = (state: State, message: string) => ({
    type: "setMessage",
    payload: { ...state, open: true, type: "warning", message: message },
});

export const setErrorMessage = (state: State, message: string) => ({
    type: "setMessage",
    payload: { ...state, open: true, type: "error", message: message},
});

export const setErrorMessageTypeAll = (state: State, message: string) => ({
    type: "all",
    payload: { ...state, open: true, type: "error", message: message, loading: false },
});
